import React from "react";
import ReactPlayer from "react-player";

class YoutubeEmbedVideo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        const {url, width, height} = this.props;
        return (
            <div>
                <ReactPlayer url={url}
                             width={width ? width: '100%'}
                             height={height ? height: '100%'}/>
            </div>
        );
    }
}

YoutubeEmbedVideo.propTypes = {};

export default YoutubeEmbedVideo;
